import { render, staticRenderFns } from "./CvEducation.vue?vue&type=template&id=12622d89&scoped=true"
import script from "./CvEducation.vue?vue&type=script&lang=js"
export * from "./CvEducation.vue?vue&type=script&lang=js"
import style0 from "./CvEducation.vue?vue&type=style&index=0&id=12622d89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12622d89",
  null
  
)

export default component.exports